<template>
    <div id="navType" class="background-ash pl20 pr20 pb20" v-loading="loading">
        <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>分类名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="page = 1, getList()" v-model="search.nameLike" placeholder="请输入分类名称"></el-input>
                </li>
                <li>
                    <span>状态</span>
                    <el-select size="small" class="select width100" v-model="search.status" >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="启用" value="ENABLED"></el-option>
                        <el-option label="禁用" value="DISABLED"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns" style="width:180px;">
                <el-button size="small" type="primary"  @click="page = 1, getList()">搜索</el-button>
                <el-button size="small" type="primary" plain @click="reset()">重置</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="pt20 content">
           <!--表头操作-->
           <div class="watchBar">
               <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" @click="editType()">添加分类</el-button>
                </div>
           </div>
           <!--表格-->
           <div class="tab">
               <el-table ref="checkList" size="mini" :data="list" tooltip-effect="dark" height="100%">
                   <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="分类名称" prop="name"></el-table-column>
                    <el-table-column label="网站数量">
                        <template slot-scope="scope">
                            <router-link class="pointer" :to="'/navManage?navId='+scope.row.id">{{ scope.row.websiteCount || 0 }}</router-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序值" prop="sort"></el-table-column>
                    <el-table-column label="状态" >
                        <template slot-scope="scope">{{ scope.row.status == 'ENABLED' ? '启用' : '禁用'}}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editType(scope.row)">编辑</el-button>
                            <el-button type="text" @click="deleteT(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
               </el-table>
           </div>
           <div class="page background-white text-right p20">
                <el-pagination class="pr20 pb20 background-white text-right pages" @size-change="pageSizeChange" @current-change="pageNoChange"
                    :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
            <!-- 新增、编辑 -->
            <el-dialog title="添加/编辑分类" :visible.sync="isShowType" width="580px" v-loading="loadingDialog" :close-on-click-modal="false">
                <el-form :model="addParam" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="分类名称" prop="name">
                        <el-input size="small" v-model.trim="addParam.name" class="width400" placeholder="请输入分类品名称" maxlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input size="small" v-model.trim="addParam.sort" class="width400" placeholder="请输入排序值" maxlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" class="last-form-item">
                    <el-radio-group v-model="addParam.status">
                            <el-radio  label='ENABLED'>启用</el-radio>
                            <el-radio  label='DISABLED'>禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small"  @click="isShowType = !isShowType">&emsp;取消&emsp;</el-button>
                    <el-button type="primary" size="small" @click="save">&emsp;确定&emsp;</el-button>
                </span>
        </el-dialog>
       </div>
    </div>
</template>
<script>
export default {
    name: 'navType', //导航分类
    data () {
        var checkSort = (rule, value, callback) => {
			var reg = /^(?:0|[1-9][0-9]*)$/; //验证只能输入数字
			if(!reg.test(value)){
				callback(new Error('只能输入数字'));
            }else {
				callback();
			}
		};
        return {
            loading: false,
            loadingDialog: false, //添加
            search_upback: {
                nameLike: '', // 导航分类
                status: '', // 状态：ENABLED-启用，DISABLED-禁用
            },
            search: {},
            page: 1,
            size: 10,
            list: [],
            total: 0,
            statistics: {}, //统计
            isShowType: false,
            addParam: {
                name: '',
                sort: '',
                status: 'ENABLED',
                id: null
            },
            rules: {
                name:[{required:true,message:'请输入分类名称',trigger:'blur'}],
                sort:[{validator: checkSort, trigger: 'blur'}]
            }
        }
    },
    watch: {
        isShowType (val) {
            if (!val) {
                this.addParam.name = ''
                this.addParam.sort = ''
                this.addParam.status = 'ENABLED'
                this.addParam.id = ''
                this.$refs.form.clearValidate()
            }
        }
    },
    methods: {
        // 重置搜索条件
        reset() {
            this.search = JSON.parse(JSON.stringify(this.search_back))
            this.page = 1
            this.getList()
        },
        //编辑或新增分类
        editType (val) {
            if (!!val) {
                this.addParam.name = val.name
                this.addParam.sort = val.sort
                this.addParam.status = val.status
                this.addParam.id = val.id
            }
            this.isShowType = true
        },
        //保存分类
        save () {
            this.$refs.form.validate( (validator) => {
                if (validator) {
                    this.loadingDialog = true
                    this.$http('POST', '/admin/nav/save', {}, this.addParam, (status, res) => {
                        this.loadingDialog = false
                        if (status) {
                            this.success( res.message);
                            this.isShowType = false;
                            this.getList();
                        }
                    })
                }
            })
        },
        //删除分类
        deleteT (id) {
            this.confirm('<div>是否删除选中的导航分类？</div><div class=\'color-red\'>删除后，该分类下网站的所属分类将为空</div>',(index)=>{
                layer.close(index)
                this.loading = true
                this.$http('POST', '/admin/nav/del', {}, {id: id}, (status, res) => {
                    this.loading = false
                    if (status) {
                        this.success('删除成功！');
                        this.getList ()
                    }
                })
            })
        },
        pageSizeChange(val) {
            this.size = val
            this.page = 1
            this.getList()
        },
        pageNoChange(val) {
            this.page = val
            this.getList()
        },
        reset() {
            this.search = JSON.parse(JSON.stringify(this.search_upback))
            this.page = 1
            this.getList()
        },
        getList () {
            let param = {...this.search};
            param.page = (this.page - 1);
            param.size = this.size
            if (!param.status) {
                delete param.status
            }
            this.loading = true
            this.$http('POST', '/admin/nav/page', {}, param, (status, res) => {
                this.loading = false
                if (status) {
                    console.log('res.content',res.content);
                   if(!!res.content && res.content.length > 0) {
                       this.list = res.content;
                   }else {
                       this.list = [];
                   }
                   this.total = res.totalCount;
                }
            })
        },
    },
    mounted() {
        this.search = {...this.search_upback}
        this.getList()
    },
}
</script>
<style scoped>
#navType {width: 100%;height: calc(100vh - 132px);}
#navType .content {height: calc(100% - 76px);}
#navType .content .tab {height: calc(100% - 125px);}
</style>


// WEBPACK FOOTER //
// src/views/pcNavigation/pcNavigation2/navType.vue